import React from 'react';
import './TeachersGrid.css';
import lukaszPhoto from '../../assets/images/lukasz2.png';
import kornelPhoto from '../../assets/images/kornel.png';

const TeachersGrid: React.FC = () => {
  const teachers = [
    {
      name: "Lukasz",
      role: "Wspolzalozyciel i Opiekun Ucznia",
      photo: lukaszPhoto,
      description: "Magister matematyki z pasja do nauczania. Specjalizuje sie w budowaniu motywacji i pewnosci siebie u uczniow.",
      achievements: [
        "100% zdawalnosci egzaminu maturalnego",
        "Pasjonat finskiego modelu nauczania",
        "Opiekun kontaktow z uczniami i rodzicami"
      ]
    },
    {
      name: "Kornel",
      role: "Wspolzalozyciel i Opiekun Olimpijski",
      photo: kornelPhoto,
      description: "Wielokrotny finalista Olimpiady Matematycznej. Przygotowuje uczniow do konkursow i olimpiad na najwyzszym poziomie.",
      achievements: [
        "Zwyciezca XIII Olimpiady Matematycznej Juniorow",
        "Trzykrotny mistrz Polski w Geometrii Elementarnej",
        "Przygotowuje laureatow konkursow"
      ]
    }
  ];

  return (
    <section id="teachers" className="awesome-teachers-section">
      <div className="awesome-teachers-container">
        <div className="awesome-teachers-header">
          <h2 className="awesome-teachers-title">Poznaj naszych zalozycieli</h2>
          <p className="awesome-teachers-subtitle">
            Doswiadczeni nauczyciele, ktorzy potrafia wytlumaczyc najtrudniejsze zagadnienia
          </p>
        </div>

        <div className="awesome-teachers-grid">
          {teachers.map((teacher, index) => (
            <div key={index} className="awesome-teacher-card">
              <div className="awesome-teacher-photo">
                <img src={teacher.photo} alt={teacher.name} />
              </div>
              <div className="awesome-teacher-content">
                <h3 className="awesome-teacher-name">{teacher.name}</h3>
                <p className="awesome-teacher-role">{teacher.role}</p>
                <p className="awesome-teacher-description">{teacher.description}</p>

                <div className="awesome-teacher-achievements">
                  <h4 className="awesome-achievements-title">Osiagniecia</h4>
                  <ul className="awesome-achievements-list">
                    {teacher.achievements.map((achievement, idx) => (
                      <li key={idx}>
                        <svg viewBox="0 0 20 20" fill="currentColor">
                          <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                        </svg>
                        {achievement}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TeachersGrid;
